import { useSyncExternalStore } from "react"
import { store } from "@/core/store"
import { postBotSessionIdentity } from "../utils/sessionIdentity"

export const currentPostBotSession = () =>
  postBotSessionIdentity(store.getState().auth)
export function usePostBotSession() {
  return useSyncExternalStore(store.subscribe, currentPostBotSession)
}
